var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueSettingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9578",
    "data-name": "Group 9578",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#335089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5888ea"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    "data-name": "Path 3779",
    d: "M0,0H17V17H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3780",
    "data-name": "Path 3780",
    d: "M2.093,10.237a7.042,7.042,0,0,1,0-2.309A1.785,1.785,0,0,0,3.847,6.914a1.783,1.783,0,0,0-.524-1.957A7.042,7.042,0,0,1,4.957,3.323a1.785,1.785,0,0,0,1.958.524A1.783,1.783,0,0,0,7.927,2.093a7.042,7.042,0,0,1,2.311,0,1.784,1.784,0,0,0,1.013,1.755,1.783,1.783,0,0,0,1.957-.524,7.042,7.042,0,0,1,1.634,1.633,1.785,1.785,0,0,0-.524,1.958,1.783,1.783,0,0,0,1.755,1.013,7.042,7.042,0,0,1,0,2.311,1.784,1.784,0,0,0-1.755,1.013,1.783,1.783,0,0,0,.524,1.957,7.042,7.042,0,0,1-1.633,1.634,1.785,1.785,0,0,0-1.958-.524,1.783,1.783,0,0,0-1.013,1.755,7.042,7.042,0,0,1-2.311,0,1.784,1.784,0,0,0-1.013-1.755,1.783,1.783,0,0,0-1.957.524,7.042,7.042,0,0,1-1.634-1.633,1.785,1.785,0,0,0,.524-1.958,1.783,1.783,0,0,0-1.755-1.013Zm6.99.97A2.125,2.125,0,1,0,6.958,9.083,2.125,2.125,0,0,0,9.083,11.208Z",
    transform: "translate(-0.583 -0.583)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSettingIcon);
export default __webpack_public_path__ + "static/media/blueSettingIcon.8e6fea2906d38c5c743858c3bd7cf017.svg";
export { ForwardRef as ReactComponent };